<template>
	<v-card :style="{ height }">
		<v-card-title v-if="title || customTitle" class="title-bar px-4 py-0" :class="titleColor">
			<div v-if="customTitle" class="fancy-dialog-title">
				<div v-html="customTitle" :class="{ 'white--text': whiteTitleText }" />
			</div>
			<div v-else class="fancy-dialog-title">
				<span v-for="(word, index) in wordSplit(title)" :key="index">
					<span v-if="index > 0">&nbsp;</span>
					<span class="capital-letter">{{ word.firstLetter }}</span>
					<span class="lowercase-letter">{{ word.minusFirstLetter }}</span>
				</span>
			</div>
			<v-icon
				v-if="icon"
				class="ml-2"
				style="font-size: 30px"
				:color="whiteTitleText ? 'white' : 'grey darken-4'">
				{{ icon }}
			</v-icon>
			<v-spacer />
			<div class="d-flex align-center">
				<slot name="upper-right-corner">
					<v-btn
						v-if="closeButton"
						icon
						:color="whiteTitleText ? 'white' : 'grey darken-3'"
						outlined
						@click="$emit('close')">
						<v-icon>mdi-close-thick</v-icon>
					</v-btn>
				</slot>
			</div>
		</v-card-title>
		<div
			v-if="dialogId"
			@click="copyId(dialogId)"
			class="yellow text-caption px-1 font-weight-medium rounded-bl copy-id-container">
			{{ dialogId }}
		</div>
		<div :class="['overflow-y-auto', `content-container${hideActions ? '-sans-actions' : ''}`]">
			<slot />
		</div>
		<v-card-actions v-if="!hideActions" :class="['pa-2', actionBarColor]">
			<v-container fluid class="pa-0">
				<v-row no-gutters>
					<v-col cols="4" class="d-flex align-center justify-start">
						<v-checkbox
							v-if="farLeftCheckbox"
							input-value="farLeftCheckbox.value"
							:label="farLeftCheckbox.label"
							hide-details
							class="mt-0"
							@change="farLeftCheckbox.change" />
						<v-btn
							v-if="farLeftButton && !farLeftButton.hidden"
							:id="farLeftButton.id || ''"
							text small
							:color="farLeftButton.color || 'red'"
							:disabled="farLeftButton.disabled"
							@click="farLeftButton.click">
							{{ farLeftButton.text }}
						</v-btn>
						<v-btn
							v-if="showConfirm"
							text small
							color="green"
							@click="farLeftButton.confirmClick">
							<span>Confirm {{ farLeftButton.text }}</span>
						</v-btn>
					</v-col>
					<v-col cols="4" class="d-flex align-center justify-center" />
					<v-col cols="4" class="d-flex align-center justify-end">
						<v-btn
							v-if="leftButton && !leftButton.hidden"
							:color="leftButton.color || 'grey darken-1'"
							text small
							:disabled="leftButton.disabled"
							@click="leftButton.click">
							{{ leftButton.text }}
						</v-btn>
						<v-btn
							v-if="centerButton && !centerButton.hidden"
							:color="centerButton.color || 'blue darken-1'"
							text small
							:disabled="centerButton.disabled"
							@click="centerButton.click">
							<div>
								<div>{{ centerButton.text }}</div>
								<div v-if="centerButton.hintText" class="text-caption text-capitalize">{{ centerButton.hintText }}</div>
							</div>
						</v-btn>
						<v-btn
							v-if="rightButton && !rightButton.hidden"
							:color="rightButton.color || 'green darken-1'"
							:disabled="rightButton.disabled"
							text small
							@click="rightButton.click">
							<div>
								<div>{{ rightButton.text }}</div>
								<div v-if="rightButton.hintText" class="text-caption text-capitalize">{{ rightButton.hintText }}</div>
							</div>
						</v-btn>
					</v-col>
				</v-row>
			</v-container>
		</v-card-actions>
		<slot name="belowButtonContent" />
	</v-card>
</template>
<script>
import { copyId } from '@/components/shared/DataTableWrapper'
import { wordSplit } from '@/utils'

export default {
	props: {
		title: {
			type: String,
			default: ''
		},
		customTitle: {
			type: String,
			default: ''
		},
		titleColor: {
			type: Array,
			default: function () {
				return ['blue-grey', 'lighten-3']
			}
		},
		whiteTitleText: Boolean,
		icon: {
			type: String,
			default: ''
		},
		hideActions: Boolean,
		farLeftCheckbox: {
			type: Object,
			default: () => {
				return null
			}
		},
		farLeftButton: {
			type: Object,
			default: () => {
				return null
			}
		},
		leftButton: {
			type: Object,
			default: () => {
				return null
			}
		},
		centerButton: {
			type: Object,
			default: () => {
				return null
			}
		},
		rightButton: {
			type: Object,
			default: () => {
				return null
			}
		},
		closeButton: Boolean,
		height: {
			type: String,
			default: 'unset'
		},
		showConfirm: Boolean,
		dialogId: String
	},
	data: () => ({
		copyId,
		wordSplit
	}),
	computed: {
		actionBarColor () {
			return [this.titleColor[0], 'lighten-5']
		}
	}
}
</script>
<style lang="scss" scoped>
.title-bar {
	height: $dialog-title-bar-height;
}
.copy-id-container {
	cursor: pointer;
	position: absolute;
	right: 0;
	top: $dialog-title-bar-height;
}
.copy-id-container {
	cursor: pointer;
	position: absolute;
	right: 0;
	top: $dialog-title-bar-height;
}
.content-container {
	max-height: $dialog-content-height;
}
.content-container-sans-actions {
	max-height: calc(90vh - #{$dialog-title-bar-height});
}
</style>
